import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationsService } from 'services/notificationsService';

const KEY = ['notifications', 'config'];

export function useNotificationsConfig() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => notificationsService.getConfig(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useSetNotificationsEnabled() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (isEnabled: boolean) => notificationsService.setEnabled(isEnabled),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
